import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import SophisticatedTooltipLink from '@wix/da-ds/pkg/tooltips/SophisticatedTooltipLink';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import { useSubscriptionLockFTUE } from '../../../Tier/ftue/useSubscriptionLockFTUE';
import SubscriptionLockLitFTUETooltip from '../../../Tier/ftue/SubscriptionLockLitFTUE/SubscriptionLockLitFTUETooltip';
import { getDeviationType } from '../../../DeviationViews/_helpers';
import { DeviationTypes } from '../../../types/deviation';
import SophisticatedTooltip from '../../../Popover/Preset/SophisticatedTooltip';
import SubscribeToUnlockTooltip from '../SubscribeToUnlockTooltip';
var TOOLTIP_WIDTH_PX = 256;
/** The SubscribersOnly element is wrapped by a pretty wide range of tooltips
 *  based on the viewer's relation to the deviation. */
var SubscribersOnlyTooltip = function (_a) {
    var deviation = _a.deviation, linkClassName = _a.linkClassName, children = _a.children;
    var t = useTranslation().t;
    var _b = useSubscriptionTier(deviation), tier = _b.tier, isTier = _b.isTier, isUserSubscribed = _b.isUserSubscribed, subscriptionsTabUrl = _b.subscriptionsTabUrl, needsSubscription = _b.needsSubscription;
    var isSubscriptionLockFTUEShown = useSubscriptionLockFTUE(deviation).isSubscriptionLockFTUEShown;
    var isMobile = useContext(MobileContext);
    var deviationType = getDeviationType(deviation);
    var isLitOrJournal = [
        DeviationTypes.JOURNAL,
        DeviationTypes.LITERATURE,
    ].includes(deviationType);
    if (!tier) {
        return React.createElement(React.Fragment, null, children);
    }
    // unsubscribed tier or in-tier
    var isAnUnsubscribedTier = isTier && !isUserSubscribed;
    if (needsSubscription || isAnUnsubscribedTier) {
        // if they've never seen a subscription lock before show a special tooltip
        var showLockFTUETooltip = isSubscriptionLockFTUEShown && isMobile && isLitOrJournal;
        return showLockFTUETooltip ? (React.createElement(SubscriptionLockLitFTUETooltip, { deviation: deviation, linkClassName: linkClassName }, children)) : (React.createElement(SubscribeToUnlockTooltip, { deviation: deviation }, children));
    }
    // subscribed
    var subscribedHeading = deviationType === DeviationTypes.JOURNAL
        ? t('deviation.tier.subscribersOnly.tooltip.unlockedJournal')
        : deviationType === DeviationTypes.STATUS
            ? t('deviation.tier.subscribersOnly.tooltip.unlockedPost')
            : t('deviation.tier.subscribersOnly.tooltip.unlockedContent');
    return (React.createElement(SophisticatedTooltip, { size: "large", placement: "top", width: TOOLTIP_WIDTH_PX, heading: subscribedHeading, description: tier.title, postfix: React.createElement(SophisticatedTooltipLink, { href: subscriptionsTabUrl, className: linkClassName }, t('deviation.tier.subscribersOnly.tooltip.subscriptionsLink')) }, children));
};
SubscribersOnlyTooltip.displayName = 'SubscribersOnlyTooltip';
export default SubscribersOnlyTooltip;
//# sourceMappingURL=SubscribersOnlyTooltip.js.map